// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.secondary-sidebar .sidebar-content {\n  background-color: transparent !important;\n  border: none;\n  max-width: 250px;\n}\n@media screen and (max-width: 768px) {\n.sidebar-layout {\n    position: relative;\n}\n.secondary-sidebar a.is-active {\n  background-color: transparent;\n  color: hsl(0, 0%, 29%) ;\n}\n.secondary-sidebar .menu-list a:hover {\n  background-color: hsl(0, 0%, 96%);\n}\n}\n", ""]);
// Exports
module.exports = exports;
